exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found-container[data-v-5b4ca72d]{text-align:center;width:100vw;position:absolute;height:1px}p[data-v-5b4ca72d]{font-size:5vh;font-family:Indie Flower,Franklin Gothic Medium,Arial,sans-serif;margin-right:20vw;margin-bottom:0;margin-top:30vh}h2[data-v-5b4ca72d]{font-size:20vh;color:#eee;text-shadow:0 0 3px #000,0 0 5px #fff,0 0 6px #000;font-family:Franklin Gothic Medium,Arial Narrow,Arial,sans-serif;margin-top:-2vh}", ""]);

// exports
